import React from 'react';
import { connect } from 'dva';

import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { SubjectForm } from '../../../../components'
import PropTypes from 'prop-types';
import { modelUtils } from "@/utils";
let { WizContainer, WizReduxTemplate } = framework_tool;
let {
    WizSelect,
    WizModal,
    WizTreeSelectList,
} = component_tool;
let { checkStrLength, $$, Session, dateUtils } = utils_tool;
import moment from 'moment';
class QuestionCategoryRadioSelect extends WizContainer {

    componentName = 'QuestionCategoryRadioSelect';
    static propTypes = {
        value: PropTypes.array,
        onChange: PropTypes.func,
        checkable:PropTypes.bool,
      };
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            mode: props.mode,
            modalVisible: false,
            stateSelects:props.selects,
            rowData: new Date().getTime(),
        }
    }

    _componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          this.setState({ value: nextProps.value });
        }
      }

    /**
     * 初始化时根据record判断是新增还是编辑
     */
    _componentDidMount() {
        let {mode} = this.state
        this.doActions([
            {
                path: `questionType/normalNodeList`,
                payload: {
                    key: `questionType@treeData`,
                    apiParams: { type: this.props.categoryType,mode:mode, state:1 }
                }
            }
        ])
    }
    propsAndStateOnChange = {
        treeData: this._getDataOver.bind(this),
    }
    _getDataOver(nextProps, nextState) {
        if (nextProps.treeData.code == 1) {
            if (nextProps.treeData.data && (nextProps.treeData.data instanceof Array)) {
                nextProps.treeData.data.forEach(data => {
                    this.giveKey(data)
                });
            }
        }
        return true;
    }

    /**给数据加key */
    giveKey(data) {
        data.key = data.value;
        if(!data.parentId){
            data.parentTitle = data.title
        }
        if (data.children && data.children instanceof Array) {
            data.children.forEach(children => {
                children.parentTitle = data.parentTitle+'>'+children.title
                this.giveKey(children)
            })
        }
    }

    _treeSelectOnClick(value, valueRows) {
        this.setState({
            modalVisible: true,
            rowData: new Date().getTime(),
        });
    }
    _wizSelectOnSubmit(value) {
        const { onChange } = this.props;
        this.setState({
            modalVisible: false,
        });
        this.setState({
            value: this.state.stateSelects.map(select=>select.key),
            date: new Date().getTime()
        });
        if (onChange) {
            onChange(this.state.stateSelects);
          }

    }
    //select中的change事件
    _wizSelectOnChange(value,option) {
        //
        let classify = value.map(select=>select.key)

        this.setState({
            date: new Date().getTime()
        });
        let stateSelects = value.map(key=>({key:key.key,title:key.label,label:key.label}))
        this.setState({
            stateSelects: stateSelects
        });
    }
    _wizSelectOnCancel(value) {
        this.setState({
            modalVisible: false,
        });
    }
    _renderOptions(propsSelects) {
        if (propsSelects && propsSelects.length) {

            return propsSelects.map((row, i) => this._renderOption(row))
        }
        return null
    }
    _renderOption(row) {
        if (row) {
            return (
                <WizSelect.Option key={row['key'] } value={row['title']} title={row['title']}>
                    {row['title']}
                </WizSelect.Option>
            )
        }
    }


    _render() {

        const { modalVisible ,rowData,stateSelects} = this.state
        let defaultValue = stateSelects.map(select=> {return {key:select.key,label:select.parentTitle}} )
        let checkedKeys = stateSelects.map(select=>select.key)
        let listCheck = stateSelects
        let treeData = this.props.treeData.data;
        let selectKey = stateSelects.map(select=>select.key).join(",")
        return (
            <>
                <div onClick={() => this._treeSelectOnClick()}>
                    <WizSelect
                         key={'wizSelect_' + selectKey}
                        defaultValue={defaultValue}
                        labelInValue
                        // mode={'multiple'}
                        open={false}
                        placeholder={'请选择题目分类'}
                        onChange={(value, option) => this._wizSelectOnChange(value, option)}
                    >
                    {this._renderOptions(stateSelects)}
                    </WizSelect>
                </div>

                <WizModal
                    visible={modalVisible}
                    title={'选择'}
                    width={800}
                    onOk={e => this._wizSelectOnSubmit(e)}
                    onCancel={e => this._wizSelectOnCancel(e)}
                >
                <div style={{ width: 750, overflow:"hidden" }}>
                    <WizTreeSelectList
                        treeProps={{checkStrictly:true}}
                        key={'WizTreeSelectList_' + rowData}
                        treeData={treeData}
                        checkedKeys={checkedKeys}
                        checkable={this.props.checkable}
                        listCheck={listCheck}
                        itemProps={{
                            icon: 'unordered-list',
                            title: '题目分类',
                            tips: '请勾选所属题目分类'
                        }}
                        onChange={(selects) => {
                            this.setState({
                                stateSelects: selects,
                            });

                        }}
                    />
                    </div>
                </WizModal>
            </>)
    }
}

const mapStateToProps = (state, ownProps) => {
    const { bankQuestion, questionType} = state;

    const treeData = modelUtils.getModelEntity(questionType, "questionType@treeData");
   const load = modelUtils.getLoadingState(state, "selects");

    return {
        treeData,
        ...load
    }
};
export default connect(mapStateToProps)(QuestionCategoryRadioSelect);

